<div class="bg-white d-flex justify-content-start align-items-end p-3 overlay">
  <div class="w-100">
    <div class="pb-3">
      <h1 #title class="fade-in-out title fw-normal">
        {{ actualContent().title }}
      </h1>
      @if (actualContent().subtitle) {
        <p class="text-secondary">{{ actualContent().subtitle }}</p>
      }
    </div>
    <app-progress-bar [percentage]="percentage()"></app-progress-bar>
  </div>
</div>
